export default "__VITE_ASSET__DUwMfsME__"